import React, { useState, useMemo } from 'react';
import { Stack, Box } from '@mui/material';
import { Button } from 'system/atoms';
import { candidateProfileSearchConversationSx } from 'modules/candidate-profile/styles';
import { parseUserMessageWithChips } from 'modules/candidate-profile/utils/parseUserMessageWithChips';
import { truncateMessagePreservingChips } from 'modules/candidate-profile/utils/truncateMessagePreservingChips';

const USER_MESSAGE_CHARACTER_LIMIT = 200;

type CandidateProfileUserMessageProps = {
  messageId: string;
  messageBody: string;
};

export const CandidateProfileUserMessage: React.FC<
  CandidateProfileUserMessageProps
> = ({ messageBody }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const { body: truncatedBody, isTruncated } = useMemo(
    () =>
      truncateMessagePreservingChips(messageBody, USER_MESSAGE_CHARACTER_LIMIT),
    [messageBody]
  );

  const displayText =
    isTruncated && !isExpanded ? `${truncatedBody}...` : messageBody;

  // Parse the message body to replace suggestion tags with chips
  const parsedMessage = useMemo(
    () => parseUserMessageWithChips(displayText),
    [displayText]
  );

  return (
    <Stack sx={candidateProfileSearchConversationSx.conversationUserMessage}>
      <Box
        sx={{
          whiteSpace: 'pre-wrap',
          wordWrap: 'break-word',
          '& .MuiChip-root': {
            verticalAlign: 'middle',
            margin: '0 2px'
          }
        }}
      >
        {parsedMessage}
      </Box>
      {isTruncated && (
        <Button
          variant="tertiary"
          onClick={() => setIsExpanded(!isExpanded)}
          sx={{ alignSelf: 'flex-start', mt: 0.5, p: 0 }}
        >
          {isExpanded ? 'See less' : 'See more'}
        </Button>
      )}
    </Stack>
  );
};
